<template>
  <div class="Broadcast">
    <div class="bbTop">
      <img class="aTop" src="../assets/bbTop.png" alt="" />
    </div>
    <div class="content" v-if="!show">
      <div class="conLeft">
        <div class="cinLt tongyong">
          <div class="tyTit">
            栏目介绍
          </div>
          <div class="miaoShu">
            <div>
              <img class="bbImg3" src="../assets/ybbb.png" alt="" />
            </div>
            <div class="bbPtext">
              《游呗播报》是游呗旗下一档实时资讯类栏目。游呗播报，旅游界首席AI主播为您播送最新鲜的旅游资讯。周一至周五，聚焦国内外旅游圈当天最新、最热、最快的新闻话题，网罗各大旅游目的地优惠活动，呈现最全面的旅游资讯。
            </div>
          </div>
        </div>
        <div class="cinLt tongyong">
          <div class="tyTit">
            播报员
          </div>
          <div class="miaoShu">
            <img class="bbImg2" src="../assets/yxbei.png" alt="" />
            <div class="bbPeo">
              <div class="bbPname">游小呗</div>
              <div class="bbPtext">
                出生于2017年 北京人 <br />
                职业：主持人 播音员<br />
                爱好：旅游<br />
                特点：沉稳 理性 有深度
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="conRight tongyong">
        <div class="tyTit">视频列表</div>
        <div class="vidListOut">
          <ul>
            <li
              @click="toZxDetail(item.id)"
              class="bbList"
              v-for="(item, index) in bbList"
              :key="index"
            >
              <img :src="item.video_cover" alt="" />
              <div class="bbText1">{{ item.title }}</div>
              <div class="bbText2">{{ item.brief_introduction }}</div>
            </li>
          </ul>
          <div class="aBot">
            <van-pagination
              v-model="currentPage"
              :total-items="125"
              :show-page-size="10"
              :page-count="allPage"
              force-ellipses
              @change="change"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="coun" v-else>
      <div class="top topTwo">
        <div class="topBanner dFlex">
          <div class="topInL topIn">
            <a target="index" href="https://yooobei.com/#/">
              <img src="../assets/logo.png" alt="" />
            </a>
          </div>
          <div class="topInR topIn">
            <a target="view_frame0" href="">
              <!-- <van-image
                width="58.125rem"
                height="3.875rem"
                src="../assets/tu.jpg"
              /> -->
              <img src="../assets/tu.jpg" alt="" />
            </a>
          </div>
        </div>
      </div>
      <div class="mBx">
        <a target="shouye3" @click="show2" href="https://yooobei.com/#/">首页</a
        >>
        <a target="bobao2" href="https://yooobei.com/#/Broadcast">播报</a>
      </div>
      <div class="aMid">
        <ul class="aMidLeft">
          <li
            class="zxList"
            :class="[show ? 'zxList2' : '']"
            v-for="item in bbList"
            :key="item.id"
            @click="toZxDetail(item.id)"
          >
            <div class="zxListIn">
              <img
                class="zxListIimg"
                :class="[show ? 'mbImg' : '']"
                :src="item.video_cover"
                alt=""
              />
              <div class="zxListR">
                <h3 class="zxListTit" :class="[show ? 'zxListTit2' : '']">
                  {{ item.title }}
                </h3>
                <!-- <div class="zxListRbot" :class="[show ? 'zxListRbot2' : '']">
                  <p>来源：{{ item.article_org }}</p>
                  <p>时间：{{ item.datetime }}</p>
                </div> -->
              </div>
            </div>
            <!-- <div class="zxListIn2" v-else>
              <h3 class="zxListTit"  :class="[show ? 'zxListTit2' : '']">{{ item.title }}</h3>
              <div class="zxThreeImg">
                <img class="zxListIimg" :class="[show ? 'mbImg' : '']" :src="item.img1" alt="">
                <img class="zxListIimg" :class="[show ? 'mbImg' : '']" :src="item.img2" alt="">
                <img class="zxListIimg" :class="[show ? 'mbImg' : '']" :src="item.img3" alt="">
              </div>
              <div class="zxListRbot" :class="[show ? 'zxListRbot2' : '']">
                <p>来源：{{ item.article_org }}</p>
                <p>时间：{{ item.datetime }}</p>
              </div>
            </div> -->
          </li>
        </ul>
      </div>
      <div class="aBot">
        <van-pagination
          v-model="currentPage"
          :total-items="125"
          :show-page-size="10"
          :page-count="allPage"
          force-ellipses
          @change="change"
        />
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { postybbbList } from "../utils/requerst/requerst";
import { isPc } from "../utils/util";
export default {
  data() {
    return {
      // id: 0,
      // detail: "",
      // currentPage: 1,
      // allPage: 0
      page: 1,
      bbList: [],
      currentPage: 1,
      show: false
    };
  },
  beforeCreate() {
    if (!isPc()) {
      this.show = true;
    }
  },
  methods: {
    show2() {
      this.$router.replace("/");
      document.querySelector(".top").style.display = "block";
      document.querySelector(".mid").style.display = "block";
      window.location.reload();
    },
    change(res) {
      if (res != this.page) {
        this.page = res;
        var data = {
          page: res,
          page_size: 16
        };
        document.scrollingElement.scrollTop = 410;
        postybbbList(data).then(res => {
          this.bbList = res.data.data;
          this.allPage = res.data.total_page;
        });
      }
    },
    toZxDetail(id) {
      // this.$router.push({ name:'InfDetail', params: { id: zxId} } )
      // window.open("https://yooobei.com/#/BroDetail?id=" + id);
      window.open("https://yooobei.com/#/BroDetail?id=" + id);
    }
  },
  created() {
    // if (this.$route.params.id) {
    if (!isPc()) {
      this.show = true;
    }
    let data = {
      page: 1,
      page_size: 16
    };
    postybbbList(data).then(res => {
      this.bbList = res.data.data;
      this.allPage = res.data.total_page;
    });
  },
  mounted() {
    if (!isPc()) {
      document.querySelector(".aMidLeft").style.width = "100%";
      document.querySelector(".bbTop").style.display = "none";
      document.querySelector(".top").style.display = "none";
      document.querySelector(".mid").style.display = "none";
      document.querySelector(".aMid").style.padding = "0 4%";
      document.querySelector(".aMid").style.minHeight = "1500px";
      document.querySelector(".van-pagination").style.fontSize = "30px";
      document.querySelector(".topTwo").style.display = "block";
      document.querySelector(".mBx").style.display = "flex";
      this.show = true;
    }
  },
  destroyed() {
    if (!isPc()) {
      document.querySelector(".top").style.display = "block";
      document.querySelector(".mid").style.display = "block";
      this.$emit("change", "0");
    }
    console.log("destroyed");
  }
};
</script>

<style lang="stylus">

.zxListIimg{
  width 13.75rem
  height 8.25rem
}
.mbImg{
  width 21rem
  height 14rem
}
.Information{
  padding 1.5625rem 0 0 0
  width 75rem
  margin 0 auto
}

.aTop{
  width 18.375rem
  height 2.75rem
}
.Information .aMid{
  display flex
  margin-top 1.25rem
}
.aMidLeft{
  width 44.625rem

}
.aMidR{
  margin-left 5.5rem
  border-top .125rem solid rgba(255,94,4,1);
}
.aMidRin{

  overflow hidden
  padding 0 1.25rem
  background:rgba(244,244,244,1);
  cursor pointer
  width 18.75rem
}
.zxList{
  padding .875rem 0
  border-bottom .0625rem solid #C7C7C9
}
.zxList2{
  padding 1.875rem 0
}
.zxListIn{
  display flex
}
.zxListIn2{
  display flex
  flex-direction column
}
.zxListIn2 .zxListTit{
  width 100%
}
.zxImg{
  width 13.75rem
  height 8.25rem
}
.zxListR{
  flex 1
  margin-left 1.5rem
  display flex
  flex-direction column
  justify-content space-between
}
.zxListTit{
  font-size:1.375rem;
  font-weight:500;
  color #49494B
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor pointer
}
.zxListTit:hover{
  color rgba(255, 94, 4, 1)
}
.zxListRbot{
  display flex
  font-size: 1rem ;
  font-weight:500;
  color:rgba(153,153,153,1);
  justify-content space-between
  width 100%
}
.zxListRbot2{
  font-size 2rem
}
.zxThreeImg{
  width 100%
  display flex
  // flex-direction column
  justify-content space-between
  margin .625rem 0
}
.Information h6{
  font-size:1.375rem;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:1.75rem;
  margin 1.1875rem 0 1.125rem 0
}
.tjText{
  font-size:1.125rem;
  font-weight:500;
  color:rgba(102,102,102,1);
  line-height:1.75rem;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.tjText:hover{
  color rgba(255, 94, 4, 1)
}


// 页码 底部
.aBot{
  margin 5.625rem 0 5rem 0
}
.van-pagination__item--active{
  background rgba(255, 94, 4, 1)
}
.van-pagination__item{
  color  rgba(153, 153, 153, 1)
}
.van-pagination__item--active{
  color #fff
}
.zxListTit2{
  font-size 3.5rem
}
.Broadcast{
  // padding 1.5625rem 0 0 0
  width 75rem
  margin  0 auto
}
.container {
  width: 100%;
  // position: relative;
}
.content {
  padding: 1rem 0 0 0;
  display flex
}
.Broadcast .aTop{
  width 75rem
  height 13.875rem
}
.tongyong{
  border:1px solid rgba(218,223,227,1);
  padding: 0 .875rem 1.875rem .875rem
  border-top:.25rem solid #FF5E03
}
.conLeft{
  width:24.375rem;
  // height 16.4375rem;
  background:rgba(255,255,255,1);

  margin-right .75rem
}
.cinLt {
  margin-bottom .75rem
}
.tyTit{
  width:5.5rem;
  height:5.1875rem;
  font-size:1.375rem;
  color:rgba(255,94,4,1);
  line-height:5.1875rem
}
.bbImg3{
  width:7.8125rem;
  height:7.75rem;
  margin-right .6875rem
}
.bbImg2{
  width:9.75rem;
  height:11.25rem;
  margin-right .6875rem
  margin-bottom .8125rem
}
.miaoShu{
  display flex
}
.bbPtext{
  font-size:.875rem;
  color:rgba(51,51,51,1);
  line-height:1.25rem;
}
.bbPname{
  width:4.875rem;
  height:2.0625rem;
  background-image:url('../assets/duihuakuang.png')
  border-radius:.3125rem;
  text-align center
  font-size:1rem;
  color:rgba(254,254,254,1);
  line-height:1.4375rem
}
.conRight{
  flex 1
  padding-right 0
}
.bbList{
  margin-right .875rem
  cursor pointer
  height 12.5rem
  color:rgba(51,51,51,1);
}
.bbList:hover{
  color rgba(255, 94, 4, 1)
}
.bbList img{
  width:11.125rem;
  height:8.375rem;
}
.bbText1,.bbText2{
  width 11.125rem
  font-size:.875rem;

  line-height:1.25rem;
  text-align center
}
.bbText1{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height 1.25rem
}
.bbText2{
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height 2.5rem
}
.vidListOut>ul{
  display flex
  flex-wrap wrap
  min-height 48.5625rem
  align-content: flex-start;
}



// 页码 底部
.aBot{
  margin 2.625rem 0 0 0
}
.van-pagination__item--active{
  background rgba(255, 94, 4, 1)
}
.van-pagination__item{
  color  rgba(153, 153, 153, 1)
}
.van-pagination__item--active{
  color #fff
}
</style>
